import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { addBanker, addStateCities, getBank, getStateWiseCities, updateBanker, updateStateCities } from "../../../services/userMasterUser";

export default function StateCitiesCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [stateCitiesList, setStateCitiesList] = useState([])
  const [input, setInput] = useState({
    state: state?.state || "",
    city: state?.city || "",
    status: state?.status || true,
  });

  useEffect(() => {

    const stateCitiesData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      cityIn: [],
      stateIn: []
    }

    getStateWiseCities(stateCitiesData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          // const stateList = Object.keys(Res).map((key) => ({
          //   key
          // }));

          const stateListArray = Object.keys(Res);

          const stateList = stateListArray.map((item) => ({
            label: item,
            value: item,
          }));
          
          setStateCitiesList(stateList)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));

    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
      }));
    }
  }, [state]);

  const [errors, setErrors] = useState({
    state: "",
    city: ""
  });

  const [statusData, setStatusData] = useState([
    { label: "ACTIVE", value: true },
    { label: "INACTIVE", value: false }
  ]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;

    if (!(input.state)) {
      newErrors.state = "Please Enter State";
      isValid = false;
    } else {
      newErrors.state = "";
    }

    if (!(input.city)) {
      newErrors.city = "Please Enter City";
      isValid = false;
    } else {
      newErrors.city = "";
    }

    if (input.status === "") {
      newErrors.status = "Please Choose Status";
      isValid = false;
    } else {
      newErrors.status = "";
    }

    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          id: state?.id,
          state: input.state,
          city: input.city,
          status: input.status,
        };
        updateStateCities(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/stateCities/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          state: input.state,
          city: input.city,
          status: true
        };
        addStateCities(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/stateCities/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/stateCities/list")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div>State Cities {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        State
                      </label>
                      <Dropdown 
                        style={{ width: "100%" }}
                        value={input.state} 
                        onChange={(e) => setInput({
                          ...input,
                          state: e.value,
                        })} 
                        options={stateCitiesList} 
                        optionLabel="label" 
                        placeholder="Select a State"
                        filter 
                        filterDelay={400} 
                        />
                      <div className="text-danger">{errors.state}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="status" className="form-label">
                        City
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="city"
                        name="city"
                        value={input.city}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            city: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.city}</div>
                    </div>
                  </div>
                  {state?.id && <div className="row mb-1">
                    <div className="col-md-12">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={statusData}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>
                  </div>}
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
